import React from 'react';
import ContentCurriculumEditor from '../../ContentCurriculumEditor';
import EmptyState from '../shared/EmptyState';
import { isBaselineFiled } from '@/logic/baseline';

// The curriculum is generated after the care team files the CMS baseline (WF37 → WF48), so until
// then there is nothing to manage. The placeholder must name the tracks already saved on the plan:
// the care-plan editor lets a coordinator choose them, so a bare "content is locked" reads as if
// that choice was lost.
const humanizeTrack = (t) => String(t || '').replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

/** @param {{ patient?: any, carePeriod?: any, measureStates?: any[], carePlan?: any }} props */
export default function ContentsTab({
  patient, carePeriod, measureStates, carePlan,
}) {
  const isAligned = !!(carePeriod && (carePeriod.status === 'active' || carePeriod.care_initiation_date));
  const filed = isBaselineFiled(measureStates);
  const tracks = Array.isArray(carePlan?.content_curriculum) ? carePlan.content_curriculum : [];
  const savedTracks = tracks.map(humanizeTrack).join(', ');

  if (!isAligned || !filed) {
    return (
      <div style={{ maxWidth: 520, margin: '24px auto' }}>
        <EmptyState
          icon={(
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
            </svg>
          )}
          title={isAligned ? 'Content unlocks after the baseline is filed' : 'Content unlocks after alignment'}
          description={isAligned
            ? `${savedTracks ? `Saved tracks: ${savedTracks}. ` : ''}The 12-month schedule is created the day your team files this patient\u2019s baseline with CMS. You can fine-tune which modules are delivered and when once it exists.`
            : 'Once this patient is CMS-aligned and your team files their baseline, content modules schedule automatically from the care plan. Your team can then fine-tune which modules are delivered and when.'}
        />
      </div>
    );
  }

  return <ContentCurriculumEditor patient={patient} carePeriod={carePeriod} />;
}
